
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HistorialCambioPropiedadPropietarioDto } from '@models/historial-cambio-propiedad-propietario/historialCambioPropiedadPropietarioDto.model';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class HistorialCambioPropiedadPropietarioService {

constructor(
    private http: HttpClient
  ) { }


  getAll():Observable<HistorialCambioPropiedadPropietarioDto[]>
  {
    return  this.http.get<HistorialCambioPropiedadPropietarioDto[]>("/api/HistorialCambioPropiedadPropietario/GetAll")
  }

  getAllByIdPropiedad(idPropiedad:number):Observable<HistorialCambioPropiedadPropietarioDto[]>
  {
    return  this.http.get<HistorialCambioPropiedadPropietarioDto[]>("/api/HistorialCambioPropiedadPropietario/GetAllByIdPropiedad?idPropiedad="+idPropiedad)
  }


}
